import { render, staticRenderFns } from "./Vesti.vue?vue&type=template&id=28f24ba5&"
import script from "./Vesti.vue?vue&type=script&lang=js&"
export * from "./Vesti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports